<template>
    <div>
        <zm-row v-if="!generateMetricsCardQuery">
            <zm-button size="small" @click="back()" plain style="float: right">Cancel</zm-button>
            <zm-button size="small" type="primary" @click="save()" :loading="loading" style="margin-right: 10px;float: right">Save</zm-button>
        </zm-row>
        <div class="divider" v-if="!generateMetricsCardQuery"></div>
        <zm-row v-else>
            <zm-button size="small" type="icon" icon="zm-icon-close" @click="deleteCard()" style="margin-right: 10px;float: right"></zm-button>
        </zm-row>
        <zm-form :model="form" :rules="rules" label-position="left" ref="form" label-width="180px">
            <zm-form-item prop="name">
                <div slot="label">
                    <tip label="Name" id="manage-dashboard-card-name"></tip>
                </div>
                <zm-input size="small" v-model="form.name"></zm-input>
            </zm-form-item>
            <zm-form-item prop="description">
                <div slot="label">
                    <tip label="Description" id="manage-dashboard-card-description"></tip>
                </div>
                <zm-input size="small" v-model="form.description"></zm-input>
            </zm-form-item>
            <zm-form-item prop="limit">
                <div slot="label">
                    <tip label="Limit" id="manage-dashboard-card-limit"></tip>
                </div>
                <zm-input-number size="small" v-model="form.cubeMonitorQuery.limit" :min="0"></zm-input-number>
            </zm-form-item>
            <zm-form-item label-width="0">
                <zm-checkbox v-model="form.active">
                    <tip label="Active" id="manage-dashboard-active"></tip>
                </zm-checkbox>
            </zm-form-item>
        </zm-form>
        <div class="chart"></div>
        <div class="query-wrapper">
            <div class="query-part">
                <div class="query-header">
                    Service
                </div>
                <div style="overflow-y: scroll;height: calc(100% - 45px);" v-loading="loadingService">
                    <div v-for="item in databases" :key="item" class="query-item" @click.prevent="setDB(item)"
                    :class="item === form.cubeMonitorQuery.database ? 'selected-item' : ''">
                        <span>{{ item }}</span>
                    </div>
                </div>
            </div>
            <div class="query-part">
                <div class="query-header">
                    Measurement & Tag
                </div>
                <div style="overflow-y: scroll;height: calc(100% - 45px);" v-loading="loadingMeasurement">
                    <zm-tree
                        class="measurement-tree"
                        ref="measurementTree"
                        lazy
                        :props="{ isLeaf: 'isLeaf' }"
                        :load="loadMeasurementNode"
                        :data="measurements"
                        node-key="id"
                        @node-expand="onExpand"
                        :default-expanded-keys="defaultExpandMeasurement"
                        :expand-on-click-node="false">
                        <span class="custom-tree-node show-hide" slot-scope="{ node, data }">
                            <span v-if="node.label">{{ node.label }}</span>
                            <zm-button :style="data.isGroup ? '' : 'display:none'" @click="setGroup(data)" class="group-btn"
                            type="primary" size="mini" v-if="data.type === 'tag'">Group by {{ node.label }}</zm-button>
                            <zm-select v-model="data.value" v-if="data.type === 'value'" style="width: 100%;" :max-line="5"
                            multiple :checkbox-options="data.data" filterable popper-append-to-body>
                            <zm-option v-for="item in data.data" :key="item.value" :value="item.value" :label="item.value"></zm-option>
                            </zm-select>
                        </span>
                    </zm-tree>
                </div>
            </div>
            <div class="query-part">
                <div class="query-header">
                    Fields
                </div>
                <div style="overflow-y: scroll;height: calc(100% - 45px);" v-loading="loadingField">
                    <zm-tree
                        class="fileds-tree"
                        show-checkbox
                        ref="fieldTree"
                        :data="fields"
                        node-key="id"
                        :default-expanded-keys="defaultExpandField"
                        @check-change="handleCheckChange">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>
                            <zm-tag type="" size="mini" v-if="data.type === 'fields' && data.checkedFunc.length">{{ data.checkedFunc.length }} Function</zm-tag>
                        </span>
                    </zm-tree>
                </div>
            </div>
        </div>
        <div class="divider"></div>
        <zm-row>
            <time-picker-option @setTimeRange="setChartTimeRange" ref="timePickerOption"></time-picker-option>
            <zm-button size="small" type="primary" @click="queryChart()" plain :loading="loading" style="margin-right: 10px;">Query</zm-button>
        </zm-row>
        <div class="chart-wrapper" id="chart">
            <ve-line :data="chartData" :extend="chartExtend" width="99%" height="calc(100% - 30px)" :settings="chartSettings"
                :legend-visible="true" :events="chartEvents" ref="chart" :legend="chartExtend.legend"></ve-line>
        </div>
    </div>
</template>
<script>
import { listMyDataBases, listMyMeasurements, listMeasurementFields, listMeasurementTags, listMeasurementTagValues, createMetricsCard, getMetricsDataFromZRMonitor, getMetricsCardDetail, updateMetricsCard } from '@/api/manageDashboard'
import tip from 'components/ToolTip/index'
import TimePickerOption from '@/components/TimeRangePicker/index'
export default {
    name: 'card',
    components: {
        tip,
        TimePickerOption
    },
    props: ['generateMetricsCardQuery', 'databaseList', 'index'],
    data () {
        var _this = this
        return {
            cardId: '',
            timeZone: 0,
            loading: false,
            loadingService: false,
            loadingMeasurement: false,
            loadingField: false,
            cardTypeList: [],
            databases: [],
            measurements: [],
            tags: [],
            fields: [],
            groupName: '',
            form: {
                id: '',
                name: '',
                dashboardId: '',
                description: '',
                active: false,
                cardType: '',
                cubeMonitorQuery: {
                    database: '',
                    fieldFuncParams: [],
                    labels: {},
                    limit: 0,
                    measurement: '',
                    tags: []
                },
                endTime: '',
                startTime: '',
                step: 1,
                stepUnit: 'm'
            },
            labelsList: [],
            selectedFields: [],
            functions: ['mean', 'count', 'min', 'max', 'sum'],
            defaultExpandMeasurement: [],
            defaultExpandField: [],
            chartData: {
                columns: ['time'],
                rows: []
            },
            chartSettings: {
                yAxisName: ['']
            },
            chartEvents: {
                click: function (e) {
                    _this.chartExtend.legend.selected = {}
                    if (!_this.isSelected || (_this.isSelected && _this.isSelected !== e.seriesName)) {
                        _this.isSelected = e.seriesName
                        _this.chartExtend.legend.data.map(item => {
                            if (item === e.seriesName) {
                                _this.chartExtend.legend.selected[item] = true
                            } else {
                                _this.chartExtend.legend.selected[item] = false
                            }
                        })
                    } else {
                        _this.isSelected = ''
                        _this.chartExtend.legend.data.map(item => {
                            _this.chartExtend.legend.selected[item] = true
                        })
                    }
                },
                legendselectchanged: function (e) {
                    _this.chartExtend.legend.selected = {}
                    if (!_this.isSelected || (_this.isSelected && _this.isSelected !== e.name)) {
                        _this.isSelected = e.name
                        _this.chartExtend.legend.data.map(item => {
                            if (item === e.name) {
                                _this.chartExtend.legend.selected[item] = true
                            } else {
                                _this.chartExtend.legend.selected[item] = false
                            }
                        })
                    } else {
                        _this.isSelected = ''
                        _this.chartExtend.legend.data.map(item => {
                            _this.chartExtend.legend.selected[item] = true
                        })
                    }
                },
                legendScroll: function (e) {
                    _this.chartExtend.legend.scrollDataIndex = e.scrollDataIndex
                }
            },
            chartExtend: {
                title: {
                    show: false,
                    text: ''
                },
                legend: {
                    type: 'scroll',
                    top: 0,
                    data: [],
                    selected: {}
                },
                grid: {
                    top: 50,
                    bottom: 15,
                    containLabel: true
                },
                series: {
                    type: 'line',
                    smooth: false
                },
                tooltip: {
                    formatter: function (params) {
                        var str = params[0].axisValue
                        params.map(param => {
                            var arr = ''
                            for (var i = 0; i < param.seriesName.length / 70; i++) {
                                arr += (i >= (param.seriesName.length / 70) - 1 ? param.seriesName.slice(i * 70, (i + 1) * 70) : param.seriesName.slice(i * 70, (i + 1) * 70) + '<br />')
                            }
                            str += '<br />' + arr + ':' + param.value[1]
                        })
                        return str
                    }
                }
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.timeZone = -(new Date()).getTimezoneOffset() / 60
        this.form.dashboardId = this.$route.params.id
        this.groupName = this.$route.query.group
        this.form.endTime = (new Date()).getTime()
        this.form.startTime = (new Date()).getTime() - 60 * 30 * 1000
        this.$nextTick(() => {
            this.$refs.timePickerOption.startTs = this.form.startTime
            this.$refs.timePickerOption.endTs = this.form.endTime
        })
        if (this.$route.params.cardId) {
            this.cardId = this.$route.params.cardId
            this.initEdit()
        } else if (this.generateMetricsCardQuery) {
            this.initGenerate()
        } else {
            this.fetchDatabase()
        }
        // if (this.form.cubeMonitorQuery.measurement) {
        //     this.
        // }
    },
    watch: {
        generateMetricsCardQuery () {
            this.initGenerate()
        }
    },
    methods: {
        initGenerate () {
            this.databases = this.databaseList
            this.form.name = this.generateMetricsCardQuery.name
            this.form.description = this.generateMetricsCardQuery.description
            this.form.active = this.generateMetricsCardQuery.active
            this.form.cardType = this.generateMetricsCardQuery.cardType
            this.form.cubeMonitorQuery = this.generateMetricsCardQuery.cubeMonitorQuery
            this.defaultExpandMeasurement = [this.form.cubeMonitorQuery.measurement]
            Object.keys(this.form.cubeMonitorQuery.labels).map(item => {
                this.defaultExpandMeasurement.push(this.form.cubeMonitorQuery.measurement + '_' + item)
            })
            this.fetchDatabase()
            this.fetchFields()
        },
        initEdit () {
            if (this.cardId) {
                getMetricsCardDetail(this.cardId).then(response => {
                    this.form.id = this.cardId
                    this.form.dashboardId = response.dashboardId
                    this.form.name = response.name
                    this.form.description = response.description
                    this.form.active = response.active
                    this.form.cardType = response.cardType
                    this.form.cubeMonitorQuery = response.cubeMonitorQuery
                    this.defaultExpandMeasurement = [this.form.cubeMonitorQuery.measurement]
                    Object.keys(this.form.cubeMonitorQuery.labels).map(item => {
                        this.defaultExpandMeasurement.push(this.form.cubeMonitorQuery.measurement + '_' + item)
                    })
                    this.fetchDatabase()
                    this.fetchMeasurement()
                    this.fetchFields()
                })
            }
            this.fields = []
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.form.cubeMonitorQuery.fieldFuncParams = []
                    this.fields.map(field => {
                        field.checkedFunc.map(func => {
                            this.form.cubeMonitorQuery.fieldFuncParams.push({
                                fieldName: field.label,
                                selectAggFunc: func
                            })
                        })
                    })
                    this.form.cubeMonitorQuery.tags = []
                    this.form.cubeMonitorQuery.labels = {}
                    this.measurements.map(measurement => {
                        measurement.children.map(tag => {
                            if (tag.isGroup) {
                                this.form.cubeMonitorQuery.tags.push(tag.label)
                            }
                            if (tag.children.length && tag.children[0].value.length) {
                                this.form.cubeMonitorQuery.labels[tag.label] = tag.children[0].value
                            }
                        })
                    })
                    if (this.cardId) {
                        this.loading = true
                        updateMetricsCard(this.form).then(response => {
                            this.$message.success('Update card success')
                            this.loading = false
                            this.back()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = true
                        createMetricsCard(this.form).then(response => {
                            this.$message.success('Create card success')
                            this.loading = false
                            this.back()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        queryChart () {
            this.form.cubeMonitorQuery.fieldFuncParams = []
            this.fields.map(field => {
                field.checkedFunc.map(func => {
                    this.form.cubeMonitorQuery.fieldFuncParams.push({
                        fieldName: field.label,
                        selectAggFunc: func
                    })
                })
            })
            this.form.cubeMonitorQuery.tags = []
            this.form.cubeMonitorQuery.labels = {}
            this.measurements.map(measurement => {
                measurement.children.map(tag => {
                    if (tag.isGroup) {
                        this.form.cubeMonitorQuery.tags.push(tag.label)
                    }
                    if (tag.children.length && tag.children[0].value.length) {
                        this.form.cubeMonitorQuery.labels[tag.label] = tag.children[0].value
                    }
                })
            })
            this.loading = true
            getMetricsDataFromZRMonitor(this.form).then(response => {
                this.chartData.columns = ['time']
                this.chartData.rows = []
                this.chartExtend.legend.data = []
                this.chartExtend.legend.selected = {}
                if (response.data.result.length) {
                    response.data.result[0].values.map(value => {
                        const time = new Date(value[0]).getTime() + this.timeZone * 60 * 60 * 1000
                        this.chartData.rows.push({
                            time: new Date(time).getUTCFullYear() + '-' + (new Date(time).getUTCMonth() + 1) + '-' + new Date(time).getUTCDate() + ' ' + new Date(time).getUTCHours() + ':' + new Date(time).getUTCMinutes() + ':' + new Date(time).getUTCSeconds()
                        })
                    })
                    response.data.result.map(result => {
                        result.columns.map((column, index) => {
                            if (column !== 'time') {
                                const str = column + '(' + JSON.stringify(result.metric) + ')'
                                if (this.metricSelected && !this.columnSelected) {
                                    if (JSON.stringify(result.metric) === this.metricSelected) {
                                        this.chartData.columns.push(str)
                                        this.chartExtend.legend.data.push(str)
                                        this.chartExtend.legend.selected[str] = true
                                        result.values.map((value, valueIndex) => {
                                            this.chartData.rows[valueIndex][str] = value[index]
                                        })
                                    }
                                } else if (this.metricSelected && this.columnSelected) {
                                    if (JSON.stringify(result.metric) === this.metricSelected && column === this.columnSelected) {
                                        this.chartData.columns.push(str)
                                        this.chartExtend.legend.data.push(str)
                                        this.chartExtend.legend.selected[str] = true
                                        result.values.map((value, valueIndex) => {
                                            this.chartData.rows[valueIndex][str] = value[index]
                                        })
                                    }
                                } else if (!this.metricSelected && this.columnSelected) {
                                    if (column === this.columnSelected) {
                                        this.chartData.columns.push(str)
                                        this.chartExtend.legend.data.push(str)
                                        this.chartExtend.legend.selected[str] = true
                                        result.values.map((value, valueIndex) => {
                                            this.chartData.rows[valueIndex][str] = value[index]
                                        })
                                    }
                                } else {
                                    this.chartData.columns.push(str)
                                    this.chartExtend.legend.data.push(str)
                                    this.chartExtend.legend.selected[str] = true
                                    result.values.map((value, valueIndex) => {
                                        this.chartData.rows[valueIndex][str] = value[index]
                                    })
                                }
                            }
                        })
                    })
                    if (this.chartData.rows.length) {
                        this.chartSettings.yAxisName[0] = this.metricsName.unit
                    }
                }
                this.$nextTick(() => {
                    this.chart = this.$refs.chart.echarts
                })
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        setDB (val) {
            this.form.cubeMonitorQuery.database = val
            this.fetchMeasurement()
        },
        loadMeasurementNode (node, resolve) {
            if (node.level === 0) {
                this.fetchMeasurement()
            }
            if (node.level === 1) {
                this.form.cubeMonitorQuery.measurement = node.data.label
                this.fetchFields()
                listMeasurementTags(this.form.cubeMonitorQuery.database, node.data.label).then(response => {
                    if (response) {
                        const tags = response.data.result[0].values.map(item => {
                            return {
                                type: 'tag',
                                id: node.data.label + '_' + item[0],
                                label: item[0],
                                children: [],
                                isGroup: this.form.cubeMonitorQuery.tags.indexOf(item[0]) > -1,
                                isLeaf: false
                            }
                        })
                        this.measurements.map(item => {
                            if (item.label === node.data.label) {
                                item.children = tags
                            }
                        })
                        resolve(tags)
                    } else {
                        resolve([])
                    }
                })
            }
            if (node.level === 2) {
                listMeasurementTagValues(this.form.cubeMonitorQuery.database, node.parent.data.label, node.data.label).then(response => {
                    if (response) {
                    const data = response.data.result[0].values.map(item => {
                        return {
                            value: item[1],
                            label: item[1]
                        }
                    })
                    node.data.children = [{
                        type: 'value',
                        id: node.parent.data.label + '-' + node.data.label + '-' + 'value',
                        label: '',
                        value: this.form.cubeMonitorQuery.labels[node.data.label] || [],
                        data: data,
                        isLeaf: true
                    }]
                    resolve(node.data.children)
                    } else {
                        resolve([])
                    }
                })
            }
        },
        onExpand (data, node, el) {
            if (data.type === 'measurement') {
                this.$refs.measurementTree.$children.map(item => {
                    if (item.node.data.label !== data.label) {
                        item.expanded = false
                    }
                })
            } else if (data.type === 'tag') {
            }
        },
        setGroup (data) {
            data.isGroup = !data.isGroup
        },
        fetchDatabase () {
            if (!this.databases.length) {
                this.loadingService = true
                listMyDataBases().then(response => {
                    this.databases = response
                    this.loadingService = false
                }).catch(() => {
                    this.loadingService = false
                })
            }
        },
        fetchMeasurement () {
            if (this.form.cubeMonitorQuery.database) {
                this.loadingMeasurement = true
                listMyMeasurements(this.form.cubeMonitorQuery.database).then(response => {
                    this.loadingMeasurement = false
                    this.form.cardType = response.cardType
                    this.measurements = response.data.result[0].values.map(item => {
                        return {
                            type: 'measurement',
                            id: item[0],
                            label: item[0],
                            children: []
                        }
                    })
                }).catch(() => {
                    this.loadingMeasurement = false
                })
            }
        },
        handleCheckChange (data, checked, indeterminate) {
            if (data.type === 'value') {
                this.fields.map(item => {
                    if (item.id === data.id.split('-')[0]) {
                        if (checked) {
                            item.checkedFunc.push(data.label)
                        } else {
                            item.checkedFunc.splice(item.checkedFunc.indexOf(data.label), 1)
                        }
                    }
                })
            }
        },
        fetchFields () {
            if (this.form.cubeMonitorQuery.database && this.form.cubeMonitorQuery.measurement) {
                this.loadingField = true
                listMeasurementFields(this.form.cubeMonitorQuery.database, this.form.cubeMonitorQuery.measurement).then(response => {
                    this.loadingField = false
                    const checkedKeys = []
                    this.fields = response.data.result[0].values.map(item => {
                        const checkedFunc = []
                        this.form.cubeMonitorQuery.fieldFuncParams.map(param => {
                            if (param.fieldName === item[0]) {
                                if (this.defaultExpandField.indexOf(param.fieldName) === -1) {
                                    this.defaultExpandField.push(param.fieldName)
                                }
                                checkedFunc.push(param.selectAggFunc)
                            }
                        })
                        return {
                            type: 'fields',
                            id: item[0],
                            checkedFunc,
                            label: item[0],
                            children: this.functions.map(value => {
                                if (checkedFunc.indexOf(value) > -1) {
                                    checkedKeys.push(item[0] + '-' + value)
                                }
                                return {
                                    type: 'value',
                                    id: item[0] + '-' + value,
                                    label: value,
                                    children: []
                                }
                            })
                        }
                    })
                    this.$refs.fieldTree.setCheckedKeys(checkedKeys)
                }).catch(() => {
                    this.loadingField = false
                })
            }
        },
        setChartTimeRange (val, timeZone) {
            this.timeZone = timeZone
            this.form.startTime = val[0] || ''
            this.form.endTime = val[1] || ''
        },
        deleteCard () {
            this.$confirm('Sure to delete the card?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$emit('deleteCard', this.index)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        back () {
            this.$router.push({
                path: '/dashboard/manage/dashboard',
                query: {
                    id: this.form.dashboardId,
                    group: this.groupName
                }
            })
        }
    }
}
</script>
<style scoped>
.query-wrapper {
    height: 50vh;
    display: flex;
}
.query-part {
    width: 33%;
    border: solid 1px rgb(228, 228, 231);
    padding: 1px;
}
.query-header {
    padding-left: 10px;
    height: 40px;
    background-color: #F2F2F7;
    line-height: 40px;
    font-size: 16px;
    margin-bottom: 5px;
}
.query-item {
    color: #232333;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    padding-left: 10px;
    display: inline-block;
    text-align: left;
    width: calc(100% - 10px);
}
.query-item:hover {
    background-color: #f5f7fa;
}
.selected-item {
    background-color: #f5f7fa;
}
.custom-tree-node {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
.show-hide:hover .group-btn {
  display: inline-block !important;
}
.divider {
    display: block;
    height: 1px;
    width: 100%;
    margin: 24px 0;
    background-color: #dcdfe6;
    position: relative;
}
.divider-text {
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    position: absolute;
    background-color: #fff;
    padding: 0 20px;
    font-weight: 600;
    color: #747487;
    font-size: 14px;
}
.chart-wrapper {
    height: 40vh;
}
</style>
<style>
.fileds-tree.zm-tree .zm-tree-node .is-leaf + .zm-checkbox .zm-checkbox__inner{display: inline-block;}
.fileds-tree.zm-tree .zm-tree-node .is-leaf + .zm-checkbox{display: inline-block;}
/* .zm-tree .zm-tree-node .zm-checkbox .zm-checkbox__inner{display: none;} */
.zm-tree .zm-tree-node .zm-checkbox{display: none;}
.measurement-tree.zm-tree .zm-tree-node .is-parentExpanded .zm-tree-node__content {
    height: fit-content;
    min-height: 32px;
}
.zm-select .zm-tag {
    max-width: 22vw;
}
</style>
